/**
 * @file simple-body.component.tsx
 * @description Компонент простого тела формы объекта для Task Manager приложения, который обеспечивает отображение формы в режиме одной страницы без вкладок. Динамически рендерит поля формы на основе конфигурации, интегрируется с react-hook-form для управления состоянием, поддерживает отображение информации об авторе и дате создания/изменения объекта, включает индикатор загрузки и обработку ошибок валидации полей формы.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['moment', '@components/ui/indicators/loader', '@components/ui/base/text', 'react']
 * @related-files ['src/features/object-form/object-form.component.tsx', 'src/features/object-form/components/tabs-body.component.tsx']
 */

import moment from 'moment';
import { Loader } from '@components/ui/indicators/loader';
import { Text } from '@components/ui/base/text';
import { createElement } from 'react';
import { FullForm } from '@src/types/form-props';

/**
 * Props для компонента SimpleBody
 */
interface ISimpleBodyProps extends FullForm {
    /** Компонент формы для отображения */
    form: React.ComponentType<FullForm>;
}

export const SimpleBody = ({
    item,
    form,
    control,
    setValue,
    getValues,
    watch,
    setError,
    formErrors,
    clearErrors,
    errorListRef
}: ISimpleBodyProps) => {
    return (
        <>
            <div className="objectForm__content flex-1 h-full mr-[3.1756vmin] mt-[3.1756vmin]">
                {item ? (
                    createElement(form, {
                        control,
                        item,
                        setValue,
                        getValues,
                        watch,
                        setError,
                        formErrors,
                        clearErrors,
                        errorListRef
                    })
                ) : (
                    <Loader />
                )}
            </div>

            <div className="objectForm__footer pt-[2.1171vmin]">
                {item?.$createdAt && (
                    <Text size="m" view="ghost">
                        {`Создан ${item.$createdBy} ${moment(item.$createdAt).local().format('DD.MM.YYYY в HH:mm')}`}
                    </Text>
                )}
            </div>
        </>
    );
};
